/**
 * Extracted from snippets/pdp-timer-component-v9.liquid (inline <script> at line 681).
 * Config bridge: window.__nsPdpTimerV9Blocks, keyed by block id. The snippet renders once
 * per block, so the Liquid it needed (the block id and its settings) is now
 * handed over as data and this asset boots once per registered block —
 * same per-instance behaviour, but the code is downloaded once, cached, and
 * kept out of the HTML parse (INP work on the PDP).
 *
 * The snippet keeps the countdown line hidden until this script marks the
 * block with data-timer-ready, so the "00 days 00 hrs 00 mins" placeholder is
 * never shown. That makes three things load-bearing here:
 *   - start immediately when DOMContentLoaded has already fired (the asset can
 *     arrive after it: theme-editor section reloads, injected HTML), instead of
 *     waiting on an event that will never come;
 *   - re-initialise on shopify:section:load, clearing the previous interval so
 *     a reload does not stack a second countdown on the first;
 *   - tolerate a block without the segment or string elements rather than
 *     throwing before the line is filled.
 */

(function () {
  var cfg = window.__nsPdpTimerV9Blocks = window.__nsPdpTimerV9Blocks || {};
  var intervals = window.__nsPdpTimerV9Intervals = window.__nsPdpTimerV9Intervals || {};

  function timerBlockInit(nsBlockId, nsSettings) {
    // Clear first: a block removed in the theme editor must not keep ticking
    // against detached nodes.
    clearInterval(intervals[nsBlockId]);

    let blockEl = document.querySelector(`#block-${nsBlockId}`);
    if (!blockEl) return;

    var pstseconds = 420

    // Get settings from the block
    const startTime = new Date(`${nsSettings.startTime}`);
    const endTime = new Date(`${nsSettings.endTime}`);
    const timezone = `${nsSettings.timeZone}`;
    const resetTimer = `${nsSettings.resetTimer}` === 'true'; // Check if reset timer is enabled
    const timezoneSetting = `${nsSettings.timeZone}`; // e.g., "EST". This might now be less relevant if inputs are UTC.

    // Calculate timezone offset
    let timezoneOffset = 0;
    switch (timezone) {
      case 'PST': timezoneOffset = pstseconds; break;
      case 'EST': timezoneOffset = 240; break;
      case 'UK': timezoneOffset = 0; break;
      case 'Europe': timezoneOffset = -120; break;
      default: timezoneOffset = -480;
    }

    const newStartTime = getNewZoneTime(startTime, timezoneOffset);
    const newEndTime = getNewZoneTime(endTime, timezoneOffset);

    // Timer segments
    const daysSegment = blockEl.querySelector('#ns-timer-announce-days');
    const hoursSegment = blockEl.querySelector('#ns-timer-announce-hours');
    const minutesSegment = blockEl.querySelector('#ns-timer-announce-minutes');
    const secondsSegment = blockEl.querySelector('#ns-timer-announce-seconds');
    const timeStringEls = blockEl.querySelectorAll('#ns-timer-announce-string');
    const countdownBlock = blockEl.querySelector('#ns-timer-announce-campaign-countdown');

    // Format number helper
    function formatNumber(number) {
      return number < 10 ? `0${number}` : number;
    }

    function setText(el, text) {
      if (el) el.textContent = text;
    }

    // Adjust time for timezone
    function getNewZoneTime(oldTime, timezoneOffset) {
      return new Date(oldTime.getTime() + timezoneOffset * 60000);
    }

    // Reset timer logic
    function getNextResetTime(currentTimeUTC, resetTimezoneAbbr) {
        let targetZoneUTCOffsetMinutes;
        switch (resetTimezoneAbbr) {
            case 'PST': targetZoneUTCOffsetMinutes = pstseconds * -1; break; // Assuming PDT (UTC-7)
            case 'EST': targetZoneUTCOffsetMinutes = -240; break; // Assuming EDT (UTC-4)
            case 'UK':  targetZoneUTCOffsetMinutes = 0;    break; // Assuming GMT (UTC+0) - adjust for BST (UTC+1) if needed
            case 'Europe': targetZoneUTCOffsetMinutes = 60; break; // Assuming CET (UTC+1) - adjust for CEST (UTC+2) if needed
            default: targetZoneUTCOffsetMinutes = 0; // Default to UTC midnight
        }

        const nowInTargetZonePerspective = new Date(currentTimeUTC.getTime() + targetZoneUTCOffsetMinutes * 60000);
        const nextMidnightInTargetZonePerspective = new Date(nowInTargetZonePerspective);
        nextMidnightInTargetZonePerspective.setUTCHours(24, 0, 0, 0);
        const nextMidnightUTCms = nextMidnightInTargetZonePerspective.getTime() - (targetZoneUTCOffsetMinutes * 60000);

        return new Date(nextMidnightUTCms);
    }

    // Update countdown
    function updateCountdown() {
      const currentTime = new Date();
      let targetTime = newEndTime;
      // Use reset logic if enabled
      if (resetTimer) {
        targetTime = getNextResetTime(currentTime, timezoneSetting);
      }

      const leftTime = targetTime - currentTime;
      const totalSeconds = Math.floor(leftTime / 1000);

      // Expired (or an unparseable end date): stop, and leave the countdown
      // line hidden rather than revealing a zeroed placeholder.
      if (!(leftTime > 0)) {
        clearInterval(intervals[nsBlockId]);
        if (countdownBlock) countdownBlock.style.display = 'none';
        delete blockEl.dataset.timerReady;
        return false;
      }

      const days = Math.floor(totalSeconds / (3600 * 24));
      const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setText(daysSegment, formatNumber(days));
      setText(hoursSegment, formatNumber(hours));
      setText(minutesSegment, formatNumber(minutes));
      setText(secondsSegment, formatNumber(seconds));

      // Update timer string (compact version above the timer, if present)
      let timeString = '';
      if (days > 0) {
        timeString = ` ${formatNumber(days)}d ${formatNumber(hours)}h ${formatNumber(minutes)}m`;
      } else if (hours > 0) {
        timeString = ` ${formatNumber(hours)}h ${formatNumber(minutes)}m`;
      } else {
        timeString = ` ${formatNumber(minutes)}m ${formatNumber(seconds)}s`;
      }
      timeStringEls.forEach(el => el.textContent = timeString);

      blockEl.dataset.timerReady = '';
      return true;
    }

    if (updateCountdown()) {
      intervals[nsBlockId] = setInterval(updateCountdown, 1000);
    }

    // Initial setup
    // if (new Date() > newStartTime) {
    //   updateCountdown();
    //   var updateInterval = setInterval(updateCountdown, 1000);
    // } else {
    //   countdownBlock.style.display = 'none';
    // }

    // collapsible element inside timer
    let collapsibleEl = blockEl.querySelector('.collapsible-container');
    let collapsibleHeadingEl;
    let collapsibleWrapperEl;

    if (collapsibleEl) {
      collapsibleHeadingEl = collapsibleEl.querySelector('.ns-pdp-timer-comp-v8__collapsible-heading')
      collapsibleWrapperEl = collapsibleEl.querySelector('.wrapper')
    }

    if (collapsibleHeadingEl && !collapsibleHeadingEl.dataset.timerBound) {
      collapsibleHeadingEl.dataset.timerBound = '';
      collapsibleHeadingEl.addEventListener('click', () => {
        collapsibleHandler(collapsibleHeadingEl, collapsibleWrapperEl)
      })
    }

    function collapsibleHandler(heading, wrapper) {
      if (wrapper) {
        collapsibleEl.classList.toggle('is-open')
        wrapper.classList.toggle('is-open')
      }
    }
  }

  function bootAll() {
    Object.keys(cfg).forEach(function (id) {
      var s = cfg[id];
      if (!s || s.__booted) return;
      s.__booted = true;
      timerBlockInit(id, s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  if (!window.__nsPdpTimerV9SectionLoadBound) {
    window.__nsPdpTimerV9SectionLoadBound = true;
    document.addEventListener('shopify:section:load', function () {
      Object.keys(cfg).forEach(function (id) {
        if (cfg[id]) timerBlockInit(id, cfg[id]);
      });
    });
  }
})();
